(() => {
  if (window.__lmcdSpiralTopScript) return;
  window.__lmcdSpiralTopScript = true;
  const init = (root) => {
    if (!root || root.dataset.spiralCloneReady === 'true') return;
    root.dataset.spiralCloneReady = 'true';
    const cleanup = [];
    const listen = (target, type, handler, options) => {
      if (!target) return;
      target.addEventListener(type, handler, options);
      cleanup.push(() => target.removeEventListener?.(type, handler, options));
    };

    const scrim = root.querySelector('[data-spiral-scrim]');
    const menu = root.querySelector('[data-spiral-menu-drawer]');
    const info = root.querySelector('[data-spiral-info-drawer]');
    const closePanels = () => {
      [menu, info].forEach((panel) => {
        panel?.classList.remove('is-open');
        panel?.setAttribute('aria-hidden', 'true');
      });
      scrim?.classList.remove('is-open');
      document.body.classList.remove('spiral-clone-panel-open');
    };
    const openPanel = (panel) => {
      closePanels();
      panel?.classList.add('is-open');
      panel?.setAttribute('aria-hidden', 'false');
      scrim?.classList.add('is-open');
      document.body.classList.add('spiral-clone-panel-open');
    };

    listen(root.querySelector('[data-spiral-menu-open]'), 'click', () => openPanel(menu));
    listen(root.querySelector('[data-spiral-menu-close]'), 'click', closePanels);
    listen(root.querySelector('[data-spiral-panel-close]'), 'click', closePanels);
    listen(scrim, 'click', closePanels);
    listen(document, 'keydown', (event) => { if (event.key === 'Escape') closePanels(); });

    root.querySelectorAll('[data-spiral-panel-open]').forEach((button) => {
      listen(button, 'click', () => {
        const key = button.dataset.spiralPanelOpen;
        root.querySelectorAll('[data-spiral-panel]').forEach((panel) => { panel.hidden = panel.dataset.spiralPanel !== key; });
        const title = root.querySelector('[data-spiral-panel-title]');
        if (title) title.textContent = button.firstChild?.textContent?.trim() || 'Details';
        openPanel(info);
      });
    });

    const stage = root.querySelector('[data-spiral-stage]');
    const media = [...root.querySelectorAll('[data-spiral-media]')];
    const thumbs = [...root.querySelectorAll('[data-spiral-thumb]')];
    let current = 0;
    const selectMedia = (index) => {
      current = (index + media.length) % media.length;
      stage?.classList.remove('is-zoomed');
      media.forEach((item, itemIndex) => {
        const active = itemIndex === current;
        item.classList.toggle('is-active', active);
        const video = item.querySelector('video');
        if (video && !active) video.pause();
      });
      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === current;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
      thumbs[current]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    };
    thumbs.forEach((thumb) => listen(thumb, 'click', () => {
      selectMedia(Number(thumb.dataset.index));
      if (!thumb.classList.contains('spiral-clone__thumb--video')) return;
      const video = media[current]?.querySelector('video');
      if (!video) return;
      video.muted = false;
      video.play().catch(() => {});
    }));
    listen(root.querySelector('[data-spiral-zoom]'), 'click', () => {
      if (media[current]?.querySelector('video')) return;
      stage?.classList.toggle('is-zoomed');
    });
    let dragStart = null;
    listen(stage, 'pointerdown', (event) => { dragStart = event.clientX; stage.setPointerCapture?.(event.pointerId); });
    listen(stage, 'pointerup', (event) => {
      if (dragStart === null) return;
      const distance = event.clientX - dragStart;
      dragStart = null;
      if (Math.abs(distance) > 42) selectMedia(current + (distance < 0 ? 1 : -1));
    });

    const quantity = root.querySelector('[data-spiral-quantity]');
    const setQuantity = (next) => { if (quantity) quantity.value = String(Math.max(1, Number(next) || 1)); };
    listen(root.querySelector('[data-spiral-quantity-minus]'), 'click', () => setQuantity(Number(quantity?.value) - 1));
    listen(root.querySelector('[data-spiral-quantity-plus]'), 'click', () => setQuantity(Number(quantity?.value) + 1));
    listen(root.querySelector('[data-spiral-bundle]'), 'click', () => setQuantity(2));
    listen(root.querySelector('[data-spiral-sticky-submit]'), 'click', () => root.querySelector('.spiral-clone__add')?.click());
    listen(root.querySelector('[data-spiral-more-payment]'), 'click', () => root.querySelector('.spiral-clone__add')?.focus());

    const hero = root.querySelector('[data-spiral-product-section]');
    const sticky = root.querySelector('[data-spiral-sticky-atc]');
    if (hero && sticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        const visible = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        sticky.classList.toggle('is-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }, { threshold: 0 });
      observer.observe(hero);
      cleanup.push(() => observer.disconnect());
    }
    root.__spiralTopTeardown = () => {
      cleanup.splice(0).forEach((remove) => remove());
      closePanels();
      media.forEach((item) => item.querySelector('video')?.pause());
      stage?.classList.remove('is-zoomed');
      sticky?.classList.remove('is-visible');
      sticky?.setAttribute('aria-hidden', 'true');
      delete root.dataset.spiralCloneReady;
      delete root.__spiralTopTeardown;
    };
  };

  const boot = () => document.querySelectorAll('[data-spiral-clone-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', (event) => {
    const node = event.target;
    if (node.matches?.('[data-spiral-clone-root]')) node.__spiralTopTeardown?.();
    node.querySelectorAll?.('[data-spiral-clone-root]').forEach((root) => root.__spiralTopTeardown?.());
  });
})();
